<template>
  <div class="page-add">
    <div class="add-title">新增音频</div>
    <el-form
      class="form"
      size="small"
      label-position="right"
      label-width="100px"
      :rules="rules"
      :model="videoForm"
      ref="videoForm"
    >
      <el-row>
        <el-col>
          <el-form-item
            class="scale"
            label="音频内容："
            prop="audioLink"
            required
          >
            <av-preview
              v-if="videoForm.audioLink"
              :src="videoForm.audioLink"
              type="audio"
              @duration="audioDuration"
              @delete="deleteAudio"
            >
            </av-preview>
            <template v-else>
              <upload
                v-show="!showProgress"
                type="audio"
                :path="'audio/audio'"
                v-model="videoForm.audios"
                @progress="audioProgress"
              />
              <div v-show="showProgress" class="progress">
                <el-progress
                  type="circle"
                  :percentage="progress.audioProgress"
                  :width="100"
                ></el-progress>
              </div>
            </template>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="音频集：" prop="audioSetId">
            <load-select
              class="form-select has-btn"
              v-model="videoForm.audioSetId"
              dictLabel="audioSetName"
              dictValue="uuid"
              :data="data"
              :page="page"
              :hasMore="more"
              :request="getData"
              placeholder="请选择所属音频集（输入名称以搜索）"
            />
            <el-button
              v-permission="'audioSet:save'"
              class="button-dept"
              @click="$router.push('/audioSet/edit')"
              >新增音频集</el-button
            >
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="音频名称：" prop="audioName" required>
            <el-input
              v-model="videoForm.audioName"
              placeholder="请输入音频名称"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="scale" label="音频封面：">
            <av-preview
              v-if="videoForm.coverUrl"
              :src="videoForm.coverUrl"
              type="image"
              @delete="deleteCover"
            />
            <upload
              v-else
              :draggable="false"
              :path="'audio/img'"
              type="image"
              v-model="videoForm.covers"
            />
            <span class="img_tip">建议尺寸：300px*300px（或1:1）</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="form-handle tl-cneter" label-width="0">
            <el-button @click="resetForm">重置</el-button>
            <el-button type="primary" @click="submit">提交</el-button>
            <back-button :pathOptions="pathOptions" :floatLeft="false" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import videoForm from "@/mixins/audio-form";
import { saveAudio } from "@/api/audio";
import Upload from "@/components/upload/index";
import AvPreview from "@/components/av-preview/index";
import LoadSelect from "@/components/load-select/index.vue";
import { getAudioListByName } from "@/api/audioSet";
import { setItem } from "@/utils/storage.js";
import BackButton from "@/components/backButton/index.vue";

export default {
  name: "audioAdd",
  mixins: [videoForm],
  components: { Upload, AvPreview, LoadSelect, BackButton },
  data() {
    return {
      pathOptions: {
        path: "/audio",
      },
      page: 1,
      more: true,
      data: [],
    };
  },
  methods: {
    getData({ page = 1, more = false, keyword = "" } = {}) {
      return new Promise((resolve) => {
        getAudioListByName({ page, audioSetName: keyword }).then(
          ({ code, data }) => {
            if (code !== 0) return;
            if (more) {
              this.data = [...this.data, ...data.records];
            } else {
              this.data = data.records;
            }
            this.page = data.current;
            let { current, total, size } = data;
            this.more = current * size < total;
            this.page = current;
            resolve();
          }
        );
      });
    },
    //新增音频
    submit() {
      this.$refs["videoForm"].validate().then(() => {
        let params = { ...this.videoForm };
        delete params.videos;
        delete params.covers;
        saveAudio(params).then((res) => {
          if (!res || res.code != 0) return;
          setItem(this.REFRESH_FLAG, true);
          this.$message({
            message: "音频新增成功！",
            type: "success",
          });
          this.$router.back();
        });
      });
    },
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === "audioSet/edit") {
      this.$store.commit("app/setKeepAlive", "audioAdd");
    } else {
      this.$store.commit("app/setNotKeepAlive", "audioAdd");
    }
    next();
  },
};
</script>

<style lang="scss" scoped>
$textColor: #51627d;
$textSize: 14px;
.form-select {
  width: 100%;
  &.has-btn {
    width: calc(100% - 110px);
  }
}
.button-dept {
  margin-left: 10px;
  width: 100px;
}
.progress {
  outline: none;
  border: 1px dashed #d9d9d9;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  width: 260px;
  height: 160px;
}
.tl-cneter {
  text-align: center;
}
</style>
